import { Cell } from '../../../../components/common/table/Cell/Cell';
import { Row } from '../../../../components/common/table/Row/Row';
import './ListRowDoseEngine.scss';
import { Button } from 'src/components/Button/Button';
import { FilingCabinet } from 'src/icons/FilingCabinet';
import { DownloadIcon } from 'src/icons/Download';
import { Upload } from 'src/icons/Upload';
import { fetchAuthenticated } from 'src/controllers';
import { WAS_BACK_END_API_URL } from 'src/constants';
import { v4 } from 'uuid';
import { useContext, useEffect, useState } from 'react';
import { BannerMessageContext } from 'src/shared/contexts/BannerMessageContext';
import { convertTime } from 'src/components/common/convertDateTime/convertDateTime';

export interface ListRowDoseEngineProps {
  val: any;
  index: number;
  token: string | null;
  key: any;
  showUploadPopup: (show: boolean) => void;
}

export function ListRowDoseEngine({ val, index, token, showUploadPopup }: ListRowDoseEngineProps) {
  const { addBannerMessage } = useContext(BannerMessageContext);
  const [fileName, setFileName] = useState('');
  const [fileDate, setFileDate] = useState('');

  useEffect(() => {
    const prefixes = ['table1-', 'table2-', 'table3-'];
    if (val) {
      let name = val['Key'];
      prefixes.forEach((prefix) => {
        if (name.startsWith(prefix)) name = name.replace(prefix, '');
      });
      setFileName(name);
      setFileDate(val['LastModified']);
    }
  }, [val]);

  const handleDownload = async () => {
    const url = `${WAS_BACK_END_API_URL}/w1/commissioning/${val['Key']}`;
    try {
      const config: RequestInit = {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      const response = await fetchAuthenticated<any>(url, config);

      if (response?.ok) {
        try {
          // i want to download the file associated with this presigned url
          let newUrl = response.parsedBody?.result?.preSignedUrl;
          if (newUrl && val) {
            const link = document.createElement('a');
            link.href = newUrl;
            link.setAttribute('download', val);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link); // Clean up the DOM
          } else {
            throw new Error('');
          }
        } catch (e) {
          addBannerMessage({
            id: v4(),
            message: JSON.stringify(e),
            type: 'error',
          });
        }
      }
    } catch (e) {
      addBannerMessage({
        id: v4(),
        message: JSON.stringify(e),
        type: 'error',
      });
    }
  };
  const handlePeopleButton = async () => {};

  const handleUploadPopup = async () => {
    showUploadPopup(true);
  };

  return (
    <Row index={index}>
      <Cell capitalized>{fileName}</Cell>
      <Cell>{convertTime(fileDate)}</Cell>
      <Cell>
        <Button
          label={''}
          onClick={() => handleDownload()}
          className={'action-button'}
          height="45px"
          width="45px"
          icon={<DownloadIcon color={'white'} height={24} width={24} />}
          iconPlacement="left"
        />
        <Button
          height="45px"
          width="45px"
          type="primary"
          label={''}
          onClick={() => handleUploadPopup()}
          className={'action-button'}
          icon={<Upload color={'white'} />}
          iconPlacement="left"
        />
        <Button
          height="45px"
          width="45px"
          label={''}
          onClick={() => handlePeopleButton()}
          className={'action-button'}
          icon={<FilingCabinet color={'white'} />}
          iconPlacement="left"
        />
      </Cell>
      <Cell>{'clinical'}</Cell>
    </Row>
  );
}
